// extracted by mini-css-extract-plugin
export var animationSlider = "BodyCondition-module--animationSlider--cfe62";
export var cardslide = "BodyCondition-module--cardslide--39ea7";
export var cardslideCondition = "BodyCondition-module--cardslideCondition--cbeb0";
export var largepaginationcontrol = "BodyCondition-module--largepaginationcontrol--2eb23";
export var swiper = "BodyCondition-module--swiper--bb473";
export var swiperwrapper = "BodyCondition-module--swiperwrapper--98d03";